var cell_default = {
  "cell": "c2Kx2",
  "header": "SjQyF",
  "selected": "QKTSm",
  "editing": "rM2cX",
  "singleSelection": "VF1Un",
  "hideLastBlock": "CCmlq",
  "editorWrapper": "r1o1a",
  "viewerWrapper": "JWtQu",
  "hideFirstBlock": "a-uT1",
  "editor": "wJ8wK",
  "edit": "V-Vhe",
  "view": "_4nC4N",
  "editingToolbarWrapper": "CJSnN",
  "selectAll": "CIojU",
  "disableSelection": "sEY5c"
};
export {
  cell_default as default
};
//# sourceMappingURL=cell-scss.js.map
